import React from "react";

class ModalButtons extends React.Component {
  _removeModal(e) {
    if (this.props.modalCloseCallback) {
      this.props.modalCloseCallback();
    }
    Fraction.Helpers.removeModal(e);
  }

  render() {
    var buttons = this.props.buttons || [];
    var modalButtons;
    if (this.props.children) {
      return <div className="modal-buttons">{this.props.children}</div>;
    } else if (buttons.length > 0) {
      return (
        <div className="modal-buttons">
          {buttons.map(button => (
            <button
              key={"modal-button" + button.label}
              className={
                (button.defaultClass || "submit ") + (button.color || "")
              }
              onClick={e => {
                button.click(e);
              }}
            >
              {button.label}
            </button>
          ))}
        </div>
      );
    } else {
      return <span />;
    }
  }
}

export default ModalButtons;
